var _excluded = ["text", "property", "width", "sortable"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Table } from "../..";
import { createElement as _createElement } from "react";
var AdvancedTableColumn = function AdvancedTableColumn(_ref) {
  var column = _ref.column,
    sort = _ref.sort,
    onSort = _ref.onSort;
  var text = column.text,
    property = column.property,
    width = column.width,
    sortable = column.sortable,
    restUnfiltered = _objectWithoutPropertiesLoose(column, _excluded);
  var rest = _.omit(restUnfiltered, ['editable', 'editRenderer', 'type']);
  var handleSort = React.useCallback(function () {
    if (onSort) {
      onSort(property);
    }
  }, [property, onSort]);
  return /*#__PURE__*/_createElement(Table.HeaderCell, Object.assign({}, sortable ? {
    onClick: handleSort
  } : {
    className: 'no-sort'
  }, {
    width: width,
    sorted: sort ? {
      asc: 'ascending',
      desc: 'descending'
    }[sort] : undefined,
    key: "elementColumn-" + property
  }, rest), text);
};
AdvancedTableColumn.handledProps = ["column", "onSort", "sort"];
AdvancedTableColumn.propTypes = {
  /**
     * Définition de la colonne
     */
  column: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
     * Le sens de tri de la colonne
     */
  sort: PropTypes.oneOf(['asc', 'desc', '']),
  /**
     * Callback au tri d'une colonne
     */
  onSort: PropTypes.func
};
AdvancedTableColumn.defaultProps = {
  column: {},
  sort: '',
  onSort: null
};
export default AdvancedTableColumn;